module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-by.86764428.png";